module.exports = __webpack_public_path__ + "static/img/class-bg.8ea4f7a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/class-bg.png
// module id = DFwC
// module chunks = 1